import React from 'react'

import config from '../config.js'
import { oAuthLogin } from './actions.js'
import { Button } from '@nike/eds'

const ClientSelector = () => (
  <div>
    {Object.keys(config.clients).map(key => {
      let client = config.clients[key]
      return (
        <Button key={key} onClick={() => oAuthLogin(client)}>
          {client.name}
        </Button>
      )
    })}
  </div>
)

export default ClientSelector
